import React from 'react';
import styled from 'styled-components';
import StackUsetech from './StackUsetech';
import useScrollAnimation from '../../../hooks/useScrollAnimation';

const Container = styled.div`
    border-radius: 1rem;
    padding-block-end: 2rem;
    padding-block-start: 2rem;
    background-color: #121212;
    background-image: url(${process.env.PUBLIC_URL}/img/UsetechVectorExp.svg);
    background-repeat: no-repeat;
    background-position: 0% 65%;
    background-size: 90rem;
    opacity: 0;
    transform: translateY(2.5rem);
    transition: opacity 0.7s cubic-bezier(0.23, 1, 0.32, 1),
        transform 0.7s cubic-bezier(0.23, 1, 0.32, 1);

    &.visible {
        opacity: 1;
        transform: translateY(0);
    }

    h1 {
        margin: 0 0 1rem 0;
        padding: 0 calc(2rem + 1vw) 0 calc(2rem + 1vw);
        font-size: clamp(1.6rem, 2.5vw + 0.5rem, 2.75rem);
        font-weight: 900;
    }

    h2 {
        padding: 0 calc(2rem + 1vw) 0 calc(2rem + 1vw);
        margin-top: 0;
        font-size: clamp(1rem, 1.5vw + 0.3rem, 1.75rem);
        font-weight: 700;
    }

    p {
        padding: 0 calc(2rem + 1vw) 0 calc(2rem + 1vw);
        margin-top: 0;
        font-size: clamp(1rem, 1vw + 0.3rem, 1.3rem);
    }
`;

const ExpUsetech = () => {
    const [ref, isVisible] = useScrollAnimation();
    return (
        <Container ref={ref} className={isVisible ? 'visible' : ''}>
            <h1>USETECH / RT LABS</h1>
            <h2>frontend developer (08.22 – 04.24)</h2>
            <p>
                developed and shipped 9 government services on the gosuslugi
                portal in react and typescript, implementing complex forms with
                react hook form and integrating via rest api. refactored legacy
                react codebase, optimised redux state management, and covered
                key scenarios with cypress e2e tests in a scrum team.
            </p>
            <StackUsetech />
        </Container>
    );
};

export default ExpUsetech;
